
export class Bingo {
  constructor() {
    this.ball = new Ball();
  }

  chooseBall() {
    return this.ball.choose();
  }
}

export class Ball {
  constructor() {
    this.letter = '';
    this.number = 0;
    this.column = 0;
    this.uniqueRandom = new UniqueRandom(1, 75);
  }

  choose() {
    this.number = this.uniqueRandom.next();
    if (this.number <= 15) {
      this.letter = 'B';
      this.column = 0;
    } else if (this.number <= 30) {
      this.letter = 'I';
      this.column = 1;
    } else if (this.number <= 45) {
      this.letter = 'N';
      this.column = 2;
    } else if (this.number <= 60) {
      this.letter = 'G';
      this.column = 3;
    } else {
      this.letter = 'O';
      this.column = 4;
    }
    return this;
  }

  toString() {
    return this.letter + this.number.toString().padStart(2,'0');
  }
}

class UniqueRandom {
  constructor(min, max) {
    this.min = min;
    this.max = max;
    this.chosen = {};
  }

  next() {
    for (;;) {
      const r = this.min + Math.floor(Math.random() * (this.max - this.min) + 1);
      if (r < this.min || r > this.max) throw new Error("out of range:" + r + 
                " min:" + this.min + " max:" + this.max);
      if (!this.chosen[r]) {
        this.chosen[r] = true;
        return r;
      } else if (Object.keys(this.chosen).length >= (this.max - this.min)) {
        throw new Error("no more values chosen:" + Object.keys(this.chosen).length + 
                    " min:" + this.min + " max:" + this.max);
      }
    }
  }
}

class Pattern {
  constructor() {
    this.columns = [0x0, 0x0, 0x0, 0x0, 0x0];
  }

  unset(colNum, rowNum) {
    this.columns[colNum] &= ~(1 << rowNum);
  }     
    
  set(colNum, rowNum) {
    this.columns[colNum] |= (1 << rowNum);
  }     

  isSet(colNum, rowNum) {
    return ((this.columns[colNum] & (1 << rowNum)) > 0);
  }
}

export class Card {
  constructor(name, vals) {
    this.name = name;
    this.ballsChosen = new Pattern();
    if (vals) {
      this.values = vals;
    } else {
      this.values = [];
      for (let col = 0; col < 5; col++) {
        this.values[col] = [];
      }
      const B = new UniqueRandom(1,15);
      const I = new UniqueRandom(16,30);
      const N = new UniqueRandom(31,45);
      const G = new UniqueRandom(46,60);
      const O = new UniqueRandom(61,75);
      for (let rowNum = 0; rowNum < 5; rowNum++) {
        this.values[0][rowNum] = B.next();
        this.values[1][rowNum] = I.next();
        this.values[2][rowNum] = N.next();
        this.values[3][rowNum] = G.next();
        this.values[4][rowNum] = O.next();
      }
    }
  }

  ballChosen(ball) {
    this.values[ball.column].forEach((val, i) => {
      if (val === ball.number) {
        this.ballsChosen.set(ball.column, i);
      }
    });
  }

  toString(sep) {
    let result = '';
    for (let rowNum = 0; rowNum < 5; rowNum++) {
      for (let colNum = 0; colNum < 5; colNum++) {
        if (this.ballsChosen.isSet(colNum, rowNum)) {
          result += '*' + this.values[colNum][rowNum].toString().padStart(2, '0') + ' ';
        } else {
          result += ' ' + this.values[colNum][rowNum].toString().padStart(2, '0') + ' ';
        }
      }
      result += sep || '\n';
    }
    return result;
  }

  getRow(rowNum) {
    let result = '';
    for (let colNum = 0; colNum < 5; colNum++) {
      if (colNum === 2 && rowNum === 2) {
        result += '**** ';
      } else if (this.ballsChosen.isSet(colNum, rowNum)) {
        result += '*' + this.values[colNum][rowNum].toString().padStart(2, '0') + ' ';
      } else {
        result += '-' + this.values[colNum][rowNum].toString().padStart(2, '0') + ' ';
      }
    }
    return result;
  }
}
